import { createSlice } from '@reduxjs/toolkit';

import { INewbuildingSeoBlock } from '../../types/newbuildingSeoBlock';

export const newbuildingsSeoBlockSlice = createSlice({
  name: 'newbuildingsSeoBlock',
  initialState: { city: null, region: null } as INewbuildingSeoBlock,
  reducers: {},
});

export const { reducer: newbuildingsSeoBlockReducer } = newbuildingsSeoBlockSlice;
